import { ReactNode } from 'react';
import * as S from './styles';

interface RadioCardProps {
	active: boolean;
	disabled?: boolean;
	label: string;
	description?: string;
	onClick: () => void;
	children?: ReactNode;
}

const RadioCard = ({
	active,
	disabled,
	label,
	description,
	onClick,
	children,
}: RadioCardProps) => (
	<S.Base
		type="button"
		active={active}
		disabled={disabled}
		onClick={disabled ? undefined : onClick}
		data-testid={`radio-card-${label.toLowerCase().replace(/\s+/g, '-')}`}
	>
		<S.Info>
			<S.Label>{label}</S.Label>
			{description && <S.Description>{description}</S.Description>}
			{children}
		</S.Info>
	</S.Base>
);

export default RadioCard;
